import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import AddPart from "./Pages/Dashboard/AddPart";
import AddReview from "./Pages/Dashboard/AddReview";
import Dashboard from "./Pages/Dashboard/Dashboard";
import ManageOrders from "./Pages/Dashboard/ManageOrders";
import ManageParts from "./Pages/Dashboard/ManageParts";
import ManageUser from "./Pages/Dashboard/ManageUser";
import MyOrders from "./Pages/Dashboard/MyOrders";
import Payment from "./Pages/Dashboard/Payment";
import Profile from "./Pages/Dashboard/Profile";
import Home from "./Pages/Home/Home";
import Reviews from "./Pages/Home/Reviews";
import Login from "./Pages/Login/Login";
import RequireAdmin from "./Pages/Login/RequireAdmin";
import RequireAuth from "./Pages/Login/RequireAuth";
import Reset from "./Pages/Login/Reset";
import SignUp from "./Pages/Login/SignUp";
import PartDetail from "./Pages/PartDetail/PartDetail";
import Footer from "./Pages/Shared/Footer";
import Navbar from "./Pages/Shared/Navbar";
import NotFound from "./Pages/Shared/NotFound";
import DailyD from "./Pages/DailyD/DailyD";
import Shops from "./Pages/Shops/Shops";
import Cservice from "./Pages/Cservice/Cservice";

function App() {
  return (
    <div className="bg-gradient-to-r from-secondary from-30% via-base-100 via-40% to-secondary to-30% ">
      <Navbar></Navbar>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="home" element={<Home />} />
        <Route path="dailyD" element={<DailyD />} />
        <Route path="cService" element={<Cservice />} />
        <Route path="reviews" element={<Reviews />} />
        <Route path="shops" element={<Shops></Shops>} />
        <Route
          path="/product/:partId"
          element={<PartDetail></PartDetail>}
        ></Route>
        <Route
          path="dashboard"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        >
          <Route index element={<MyOrders></MyOrders>}></Route>
          <Route
            path="addReview"
            element={
              <RequireAuth>
                <AddReview></AddReview>
              </RequireAuth>
            }
          ></Route>
          <Route
            path="addPart"
            element={
              <RequireAdmin>
                <AddPart></AddPart>
              </RequireAdmin>
            }
          ></Route>
          <Route
            path="manageParts"
            element={
              <RequireAdmin>
                <ManageParts></ManageParts>
              </RequireAdmin>
            }
          ></Route>
          <Route
            path="manageOrders"
            element={
              <RequireAdmin>
                <ManageOrders></ManageOrders>
              </RequireAdmin>
            }
          ></Route>
          <Route
            path="manageUser"
            element={
              <RequireAdmin>
                <ManageUser></ManageUser>
              </RequireAdmin>
            }
          ></Route>
          <Route
            path="profile"
            element={
              <RequireAuth>
                <Profile></Profile>
              </RequireAuth>
            }
          ></Route>
          <Route path="payment/:id" element={<Payment></Payment>}></Route>
        </Route>

        <Route path="login" element={<Login />} />
        <Route path="signup" element={<SignUp />} />
        <Route path="reset" element={<Reset />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer></Footer>
      <ToastContainer />
    </div>
  );
}

export default App;
